module.exports = __webpack_public_path__ + "static/media/StripeLogo.837e1aea.svg";